window.addEventListener("scroll", function () {
  const header = document.querySelector(".header-wrapper");

  if (window.scrollY > 0) {
    header.classList.add("sticky-header");
  } else {
    header.classList.remove("sticky-header");
  }
});




document.addEventListener('DOMContentLoaded', function () {

  if (window.innerWidth > 749) return;

  const blocks = document.querySelectorAll('.footer-block');

  blocks.forEach(block => {

    const heading = block.querySelector('.accordion-toggle');

    if (!heading) return;

    heading.addEventListener('click', function () {
      block.classList.toggle('active');
    });

  });

});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.rating-text span').forEach(function(el) {
        let rating = parseFloat(el.textContent);
        if (!isNaN(rating)) {
            el.textContent = rating.toFixed(1);
        }
    });
});


document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.quick-add__submit').forEach(function(btn) {
        btn.textContent = 'BUY NOW';
    });
});